export default function Unauthorized() {
  return <div className="admin-table-empty">شما دسترسی لازم برای این صفحه را ندارید.</div>;
}
